export const IS_PROD = process.env.NODE_ENV === 'production';
export const API_SERVER = process.env.API_SERVER || 'http://localhost:3000/api';
export const DEFAULT_OAUTH_URL = `${API_SERVER}/users/auth/cognito`;
export const MY_CAR_URL = process.env.MY_CAR_URL || '/car-tracker/';
